import { Link } from "react-router-dom";
import { dynamicImage } from "../../Utils";
import { H4, Image, P } from "../../AbstractElements";

function HeaderLogo() {
  return (
    <>
      <div className="header-logo-wrapper col-auto">
        <div className="logo-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
            <Image className="img-fluid for-light" src={dynamicImage("logo/logo.png")} alt="logo" />
            <Image className="img-fluid for-dark" src={dynamicImage("logo/logo_light.png")} alt="logo" />
          </Link>
        </div>
      </div>
      <div className="header-welcome">
        <div className="welcome-title">
          <H4>{'Welcome!!'}</H4><Image className="img-fluid" src={dynamicImage(`giftools.gif`)} alt="" />
        </div>
        <P className="mb-0">{'Here’s what’s happening with your store today.'}</P>
      </div>
    </>
  );
};

export default HeaderLogo;
